import styled from 'styled-components';

import { YatLogo } from '@pkg/assets/brand';
import { Button } from '@pkg/components/Sections/Profile/Buttons';

import { Typography } from '../../../../../../../../../components/DesignSystem';

export const StyledYatHandWrap = styled.div`
    height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    svg {
        fill: white;
    }
`;

export const StyledTypography = styled(Typography)`
    margin: 20px 0 10px 0;
`;

export const StyledHeading = styled.h3`
    margin: 30px 0 20px 0;
    text-align: center;
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 25px;
    text-align: center;
    letter-spacing: -0.05em;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 30px;
        line-height: 30px;
    }
`;

export const StyledText = styled.p`
    && {
        text-align: center;
        font-family: 'Alliance No.1';
        font-style: normal;
        font-weight: 400;
        text-align: center;
        letter-spacing: -0.03em;
        margin: 0;
        padding: 0;
        max-width: 700px;

        font-size: 18px;
        line-height: 20px;
        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            font-size: 24px;
            line-height: 32px;
        }
    }
`;

export const UnsupportedWrapper = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 35%;
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding-bottom: 20%;
    }
`;

export const StyledButton = styled(Button)`
    && {
        margin-top: 20px;

        @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
            width: 340px;
        }
    }
`;

export const StyledYatHand = styled(YatLogo)`
    && {
        opacity: 0.1;
        height: 71px;
        width: 60px;
        fill: white;

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            height: 135px;
            width: 135px;
        }
    }
`;
